import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles } from './template.scss';
import { ImageState } from '../../../../ui/gzImageRepo/types';
import { ButtonColor, ButtonType } from '../../../../ui/gzIconButton/types/index';
import { FontSizes } from "../../../../types/common/types";

const liveSearchMetadataGridTemplate = document.createElement('template');

liveSearchMetadataGridTemplate.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="content">
      <div class="grid" class="hidden">
        <div id="metadata-header">
          <gz-button id="assign-tags-button" disabled></gz-button>
          <gz-tooltip class="tooltip"  id="download_metadata">
              <gz-icon-button
                id="liveSearchExportResultMetadataCsv"
                icon="ds-icon-export"
                fontsize="20"
                buttonType="${ButtonType.SQUARE}"
                buttonColor="${ButtonColor.SECONDARY}"
              ></gz-icon-button>
           </gz-tooltip>
        </div>
        <gz-grid-view class="grid-view"></gz-grid-view>
      </div>

      <div id="not-started" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.START}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="not-started-message"></gz-title>
          <gz-text id="not-started-additional-text" fontSize="14" lineHeight="2"></gz-text>
        </gz-image-repo>
      </div>

      <div id="no-results" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.EMPTY}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="no-results-message"></gz-title>
        </gz-image-repo>
      </div>

      <div id="in-progress" class="hidden">
        <gz-image-repo class="mt-10" state="${ImageState.EMPTY}">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="in-progress-message"></gz-title>
        </gz-image-repo>
      </div>
    </div>
  </div>
`;

export default liveSearchMetadataGridTemplate;
